import { CreateReport2Form } from './create-report-#-2-form'

export const CreateReport2 = ({
  onCloseModal,
}: {
  onCloseModal: () => void
}) => {
  return <CreateReport2Form onCloseModal={onCloseModal} />
}
